import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderBGEsubs from "../../../../src/content/bgeaesubs/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderBGEsubs,
  React
};